var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-button',_vm._b({staticClass:"is-small is-primary",class:{ 'is-inverted': !_vm.isActive }},'action-button',{ disabled: _vm.disabled },false),[_c('icon',{staticClass:"pointer-events-none",attrs:{"icon":_vm.isActive ? 'chevron-up' : 'ellipsis-v'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }